// extracted by mini-css-extract-plugin
export var popper = "_8x-0";